import React from 'react';

export const ServerStarting: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'var(--color-background-primary, #ffffff)',
        color: 'var(--color-text-primary, #1f2937)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        padding: '2rem',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          maxWidth: '500px',
        }}
      >
        <div
          style={{
            width: '64px',
            height: '64px',
            border: '4px solid var(--color-accent, #3b82f6)',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 2rem',
          }}
        />
        <h1
          style={{
            fontSize: '2rem',
            fontWeight: '600',
            marginBottom: '1rem',
            color: 'var(--color-text-primary, #1f2937)',
          }}
        >
          Server is Starting
        </h1>
        <p
          style={{
            fontSize: '1rem',
            color: 'var(--color-text-secondary, #6b7280)',
            marginBottom: '0.5rem',
          }}
        >
          Please wait while the server initializes...
        </p>
        <p
          style={{
            fontSize: '0.875rem',
            color: 'var(--color-text-tertiary, #9ca3af)',
          }}
        >
          This may take a few moments
        </p>
      </div>
      <style>
        {`
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

